import React from "react";

interface RadioButtonProps {
  checked?: boolean;
  onChange: () => void;
  isEnabled?: boolean;
  loading?: boolean; // New loading prop
  bubbleBackgroundColor?: string; // New bubble background color prop
  customBorderColor?: string; // New custom border color prop
  label: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  checked = false,
  onChange,
  isEnabled = true,
  loading = false, // Default loading state to false
  bubbleBackgroundColor,
  customBorderColor,
  label,
}) => {
  const defaultBorderColor = loading
    ? "border-transparent"
    : checked
      ? isEnabled
        ? "border-icon-blue-light"
        : "border-[#B7BBD4]"
      : isEnabled
        ? "border-grayscale-2"
        : "border-[#B7BBD4]";

  const defaultBubbleColor = isEnabled ? "bg-icon-blue-light" : "bg-[#B7BBD4]";

  const borderColor = customBorderColor || defaultBorderColor;
  const backgroundColor = loading ? "bg-[#ECECEC]" : "bg-transparent";

  const handleClick = () => isEnabled && !loading && onChange();

  return (
    <div className="flex flex-row gap-[4px] items-center">
      <div
        onClick={handleClick}
        className={`border-[1px] ${
          !checked ? "border - [#B7BBD4]" : borderColor
        } ${backgroundColor} rounded-full flex items-center justify-center cursor-${
          isEnabled && !loading ? "pointer" : "not-allowed"
        } transition-opacity duration-300 ${loading ? "animate-pulse" : ""}`}
        style={{
          width: "20px",
          height: "20px",
          minWidth: "20px",
          minHeight: "20px",
          aspectRatio: "1",
        }}>
        <div className="w-[12px] h-[12px] flex items-center justify-center">
          {!loading && checked && (
            <div
              className={`w-[10px] h-[10px] ${
                bubbleBackgroundColor || defaultBubbleColor
              } rounded-full`}
            />
          )}
        </div>
      </div>
      <span className="font-medium text-[12px]">{label}</span>
    </div>
  );
};

export default RadioButton;
